<template>
  <div class="news" id="news">
    <!-- 头部导航组件 -->
    <header-cmp></header-cmp>
    <menu-cmp></menu-cmp>
    <!-- 新增资讯内容 -->
    <section>
      <div class="banner">
        <el-carousel class="banner-carousel" height="100%" arrow="always">
          <el-carousel-item v-for="(item, index) in carousel" :key="index"
           @click="gotoDetail(item.id)">
            <img :src="item.img"  class="banner-carousel-img"  @click="gotoDetail(item.id)"/>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="news-center">
        <h2><i></i>新闻资讯</h2>
        <div class="content">
          <ul class="tab-menu">
            <li
              v-for="(item, index) in tabs"
              :key="index"
              @mouseover="handleClick(item)"
              @click="handleClick(item)"
              :class="{ active: active == item.id }"
            >
              {{ item.name }}
            </li>
          </ul>
          <announce v-show="active == 'announce'" />
          <athletics v-show="active == 'athletics'" />
          <directory v-show="active == 'directory'" />
          <!-- <router-view></router-view> -->
          
          <!-- 查看更多 -->
          <div class="more-con">
            <button class="more" @click="gotoMore">查看更多</button>
          </div>
        </div>
      </div>
    </section>
    <footer-cmp></footer-cmp>
  </div>
</template>

<script>
import headerCmp from "@/components/common/header.vue";
import menuCmp from "@/components/common/navMenu.vue";
import footerCmp from "@/components/common/footer.vue";
import announce from "./announce.vue";
import athletics from "./athletics.vue";
import directory from "./directory.vue";
import { getBanner } from "@/api/news.js";
export default {
  data() {
    return {
      carousel: [],
      tabs: [
        { id: 'announce', name: "新闻通告", path: "/news/announce" },
        { id: 'athletics', name: "田径文化", path: "/news/athletics" },
        { id: 'directory', name: "名录公示", path: "/news/directory" },
      ],
      active: this.$route.query.id || 'announce',
    };
  },
  components: {
    headerCmp,
    menuCmp,
    footerCmp,
    announce, athletics, directory
  },
  methods: {
    getBannerImg(){
      getBanner(["newsBgImg"]).then(res=>{
        this.carousel = JSON.parse(res.data.newsBgImg);
      })
    },
    handleClick(item) {
      this.active = item.id;
      // this.$router.replace(item.path);
    },

    gotoDetail(id) {
      this.$router.push(`/news/newsDetail?id=${id}`);
    },
    gotoMore() {
      if (this.active !== "directory") {
        if(this.active == "announce"){
          this.$router.push("/more?type=categorys&val=新闻资讯");
        }else{
          this.$router.push("/more");
        }
      } else {
        this.$router.push("/directoryMore");
      }
    },
  },
  mounted() {
    this.getBannerImg();
  },
  watch: {
      $route() {
        this.active = this.$route.query.id;
      }
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 961px) {
  #news {
    font-size: 14px;
    width: 100%;
    height: 100%;
    section .banner {
      width: 100%;
      height: 580px;
      .banner-carousel {
        width: 100%;
        height: 100%;
        &-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
    section {
      .news-center {
        width: 1200px;
        margin: 0 auto;
        // padding: 50px 0;
        padding: 0;
        box-sizing: border-box;
        h2 {
          font-size: 24px;
          font-weight: normal;
          padding: 30px 0;
          border-bottom: 1px solid rgba(216, 216, 216, 0.43);
          display: flex;
          align-items: center;
          i {
            display: inline-block;
            width: 4px;
            height: 28px;
            margin-right: 8px;
            background-color: #da5351;
            vertical-align: middle;
          }
        }
        .content {
          .tab-menu {
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            height: 68px;
            line-height: 68px;
            border-bottom: 1px solid rgba(216, 216, 216, 0.43);
            cursor: pointer;
            li {
              width: 33%;
              text-align: center;
              font-size: 20px;
              font-weight: 400;
              color: #666666;
              cursor: pointer;
            }
            li.active {
              color: #da5351;
              font-weight: 500;
            }
          }
          .more-con {
            width: 100%;
            text-align: center;
            button.more {
              width: 260px;
              height: 60px;
              background: linear-gradient(144deg, #ef8b89 0%, #da5351 100%);
              border-radius: 30px;
              border: none;
              color: #fff;
              font-size: 24px;
              margin: 20px auto;
              text-align: center;
              cursor: pointer;
            }
          }
          .athletics + .more-con{
            display: none;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 960px) {
  #news {
    font-size: 0.12rem;
    width: 100%;
    height: 100%;
    padding-top: 0.56rem;
    section .banner {
      width: 100%;
      height: 1.2rem;
      .banner-carousel {
        width: 100%;
        height: 100%;
        &-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
    section {
      .news-center {
        margin: 0.21rem 0.16rem 0;
        box-sizing: border-box;
        h2 {
          display: none;
        }
        .content {
          .tab-menu {
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            height: 0.28rem;
            line-height: 0.28rem;
            li {
              width: 33%;
              text-align: center;
              font-size: 0.12rem;
              color: #333;
              margin: 0 0.05rem;
              font-weight: 400;
              height: 0.28rem;
              background: #f9f9f9;
              border-radius: 0.14rem;
            }
            li.active {
              background: #da5351;
              font-weight: 500;
              color: #ffffff;
            }
          }
          .more-con {
            width: 100%;
            text-align: center;
            button.more {
              width: 33%;
              height: 0.28rem;
              background: linear-gradient(144deg, #ef8b89 0%, #da5351 100%);
              border-radius: 0.14rem;
              border: none;
              color: #fff;
              font-size: 0.12rem;
              margin: 0.05rem auto;
              text-align: center;
            }
          }
          .athletics + .more-con{
            display: none;
          }
        }
      }
    }
  }
}
</style>